import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, Button, Icon, Text } from '@perch-labs/shrike';
import { Container } from 'styles';
import { useSessionContext } from 'contexts/session';
import { copyFor } from 'config';
import {
  useFunnelRedirect,
  RedirectReason,
} from 'hooks/use-funnel-redirect.hook';
import { StyledCard } from './finish-setup-cta.style';

const getCopy = copyFor('solar.finishSetupCta');
const statePlaceholder = getCopy('statePlaceholder');

interface Props {
  state?: string;
}

export const FinishSetupCta = (props: Props) => {
  const { state = statePlaceholder } = props;
  const { userId } = useSessionContext();
  const { planId } = useParams<{ planId?: string }>();

  const [redirect, { loading: redirectLoading }] = useFunnelRedirect({
    idParams: { planId: Number(planId) },
    userId,
    reason: RedirectReason.VnmAvailable,
  });

  return (
    <StyledCard mobileVariant="flat">
      <Card.Content>
        <Container flex margin={{ top: '40px' }}>
          <Icon
            icon="ExclamationCircleInverted"
            scale={3}
            margin={{ top: '2px' }}
          />
          <Text
            textStyle="heading700"
            tag="h2"
            margin={{ bottom: '24px', left: '17px' }}
          >
            {getCopy('title')}
          </Text>
        </Container>
        <Text margin={{ bottom: '24px' }}>
          {getCopy('subTitle', { stateName: state })}
        </Text>
        <Button
          fullWidth
          onClick={redirect as (e: React.MouseEvent<HTMLButtonElement>) => void}
          loading={redirectLoading}
        >
          {getCopy('button')}
        </Button>
      </Card.Content>
    </StyledCard>
  );
};
